import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ element: Component }) => {
  const loggedIn = useSelector((state) => state.auth.loggedIn);

  // Check local storage as a fallback
  const isLoggedIn = loggedIn || localStorage.getItem("loggedIn") === "true";

  return isLoggedIn ? <Component /> : <Navigate to="/login" />;
};

export default PrivateRoute;